import type { SVGProps } from "react";

/**
 * translate,language
 * @category Typography
 */
export default function IconTranslate(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M3.75 5.81641L12.25 5.81641'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M8 5.75V3.75' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M12 14.25C7.93498 13.1983 5.84489 10.6138 5.25 6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 14C8.06352 12.9798 10.1538 10.4735 10.75 6'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.3438 17.1249H19.6562M21.25 19.2499L17.9355 10.4762C17.6098 9.61406 16.3902 9.61406 16.0645 10.4762L12.75 19.2499'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
